module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-nissan.c73d96f6.png";